/** Допустимое расхождение суммы услуг к оплате с целевой суммой, %. */
export const EU_ACCOUNT_PAYABLE_TOLERANCE_PERCENT = 1;

/** Ниже этого порога сумма считается нулевой: копейки набегают от округления курса. */
const ZERO_AMOUNT_THRESHOLD = 0.0001;

/** Расхождение выбранной суммы с целевой в процентах. Нулевая цель даёт 0 или 100. */
export function getEuAccountPayableDifferencePercent(selected: number, target: number): number {
    if (Math.abs(target) < ZERO_AMOUNT_THRESHOLD) {
        return Math.abs(selected) < ZERO_AMOUNT_THRESHOLD ? 0 : 100;
    }

    return Math.abs(selected - target) / Math.abs(target) * 100;
}

/**
 * Счёт полностью закрыт взаимозачётом: услуги к оплате не выбраны, а взаимозачёт
 * покрывает услуги за период целиком (расхождение не больше допустимого).
 *
 * Целевая сумма при этом равна нулю или копейкам от округления курса, из-за чего
 * обычная проверка расхождения даёт 100% и не даёт сохранить счёт не черновиком.
 */
export function isEuAccountFullyNetted(params: {
    hasPayableServices: boolean;
    servicesSum: number;
    nettingsSum: number;
}): boolean {
    const { hasPayableServices, servicesSum, nettingsSum } = params;

    if (hasPayableServices) {
        return false;
    }

    if (Math.abs(servicesSum) < ZERO_AMOUNT_THRESHOLD) {
        return false;
    }

    return getEuAccountPayableDifferencePercent(nettingsSum, servicesSum) <= EU_ACCOUNT_PAYABLE_TOLERANCE_PERCENT;
}
